import Footer from "../components/Footer";
import HeroPages from "../components/HeroPages";
import Person1 from "../images/team/ceo.jpg";
import Person2 from "../images/team/teamlead.jpg";
import Person3 from "../images/team/customercare.jpg";
import Person4 from "../images/team/4.png";
import Person5 from "../images/team/5.png";
import Person6 from "../images/team/6.png";

function Team() {
  const teamPpl = [
    { img: Person1, name: "Afeez Akinfola Oyinloye", job: "CEO/FOUNDER" },
    { img: Person2, name: "Muideen Akinroye Olawale", job: "Chief Technology Officer" },
    { img: Person3, name: "Saheed Hikmah", job: "Customer Support" },
    // { img: Person4, name: "Lauren Rivera", job: "Car Detailist" },
    // { img: Person5, name: "Martin Rizz", job: "Mechanic" },
    // { img: Person6, name: "Caitlyn Hunt", job: "Menager" },
  ];
  return (
    <>
      <section className="team-page">
        <HeroPages name="Our Team" />
        <div className="cotnainer">
          <div className="team-container">
            {teamPpl.map((ppl, id) => (
              <div key={id} className="team-container__box">
                <div className="team-container__box__img-div">
                  <img src={ppl.img} alt="team_img" />
                </div>
                <div className="team-container__box__descr">
                  <h3>{ppl.name}</h3>
                  <p>{ppl.job}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="book-banner">
          <div className="book-banner__overlay"></div>
          <div className="container">
            <div className="text-content">
              <h2 style={{ fontFamily: 'Montserrat'}}>Book a Ride by getting in touch with us</h2>
              <span>
                <i className="fa-solid fa-phone" style={{color:'#f7931e'}}></i>
                <h4 style={{ fontFamily: 'Montserrat', color:'#f7931e'}}>(234) 810 619 2990</h4>
              </span>
            </div>
          </div>
        </div>
        <Footer />
      </section>
    </>
  );
}

export default Team;
